<script>
export default {
  props: {
    title: { type: String, required: true },
    userOrg: { type: String, required: true },
    disable: { type: String, required: true },
  },
  methods: {
    clickHandler() {
      this.$emit('click')
    },
  },
}
</script>

<template>
  <v-btn
    :class="{
      'disabled-btn': disable === 'inactive',
      'primary-btn': disable === 'active',
    }"
    @click="clickHandler"
  >
    {{ title }}
  </v-btn>
</template>

<style lang="scss" module>
@import '@design';
</style>
